export function formatAlertMessage(value: unknown, fallback: string): string {
  if (value === null || value === undefined) return fallback;
  if (typeof value === "string") {
    const t = value.trim();
    return t.length > 0 ? t : fallback;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (Array.isArray(value)) {
    const parts = value
      .map((item) => {
        if (typeof item === "string") return item.trim();
        if (item !== null && typeof item === "object") {
          const o = item as Record<string, unknown>;
          if (typeof o.msg === "string") return o.msg.trim();
          if (typeof o.message === "string") return o.message.trim();
        }
        return String(item ?? "");
      })
      .filter((s) => s.length > 0);
    if (parts.length > 0) return parts.join(" ");
    return fallback;
  }
  if (typeof value === "object") {
    const o = value as Record<string, unknown>;
    if (typeof o.message === "string" && o.message.trim()) return o.message.trim();
    if (typeof o.error === "string" && o.error.trim()) return o.error.trim();
    if (typeof o.detail === "string" && o.detail.trim()) return o.detail.trim();
    if (Array.isArray(o.detail)) {
      const joined = o.detail.map(String).join(" ").trim();
      if (joined.length > 0) return joined;
    }
  }
  return fallback;
}
